import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=287a3f8a&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=js&"
export * from "./pay.vue?vue&type=script&lang=js&"
import style0 from "./pay.vue?vue&type=style&index=0&id=287a3f8a&prod&scoped=true&lang=scss&"
import style1 from "./pay.vue?vue&type=style&index=1&id=287a3f8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287a3f8a",
  null
  
)

export default component.exports